/**
 * Horómetro y kilometraje en bitácora: siempre 2 decimales (igual en pantalla, Excel y resúmenes).
 */
export function formatBitacoraReading(value) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  return n.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Solo dígitos y un punto decimal (máx. 2 decimales). Para inputs type="text". */
export function sanitizeBitacoraReadingInput(raw) {
  if (raw == null) return '';
  let s = String(raw).replace(/,/g, '.').replace(/[^\d.]/g, '');
  const dot = s.indexOf('.');
  if (dot === -1) return s;
  const intPart = s.slice(0, dot);
  const decPart = s.slice(dot + 1).replace(/\./g, '').slice(0, 2);
  if (!intPart && !decPart) return '';
  if (!decPart && s.endsWith('.')) return `${intPart || '0'}.`;
  return decPart ? `${intPart || '0'}.${decPart}` : intPart;
}
